export class Involvement {
  id: number;
  matter_id: number;
  notes: string;
  position: number;
  contact_id: number;
  use_email: boolean = false;
  use_mail: boolean = false;
  is_plaintiff: boolean = false;
  is_defendant: boolean = false;
  addresss_id: number;
  use_fax: boolean = false;
  email_address_id: number;
  fax_phone_number_id: number | null;
  include_spouse: boolean = false;
  include_employer: boolean = false;
  is_intervenor: boolean = false;
  vendor_id: number;
  group_by_role: boolean = true;
  phone_number_id: number | null;
  use_phone: boolean = false;
  created_by: any;
  updated_by: any;
  created_at: any;
  updated_at: any;
  addresses: Array<any> = [];
  email_addresses: Array<any> = [];
  phone_number: any;
  fax_phone_number: any;
  roles: Array<any> = [];
  address_list_ids: Array<number> = [];
  email_ids: Array<number> = [];
  relationships: Array<any> = [];
  roles_str: string;
  allow_phone_text: boolean = false;
  matter_type_name: string;
}
